import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	({
		type: 'error',
		title: messages.title,
		description: messages.description,
	}) as FlagConfiguration;
